/**
 * SectionInstructionScreen Component
 * Displays section instruction before starting questions
 */
import React from 'react';
import { SectionInstruction } from '../../types';
import Timer from '../Timer';

interface SectionInstructionScreenProps {
  instruction: SectionInstruction;
  sectionId: string | null;
  onStart: () => void;
}

export const SectionInstructionScreen: React.FC<SectionInstructionScreenProps> = ({
  instruction,
  sectionId,
  onStart
}) => (
  <div className="min-h-screen bg-neutral flex items-center justify-center p-4">
    <div className="bg-white rounded-xl shadow-xl p-6 max-w-xl w-full">
      <h2 className="text-2xl font-bold text-primary mb-4">
        {instruction.section_name}
      </h2>
      
      {instruction.time_limit && (
        <div className="mb-4">
          <Timer 
            duration={instruction.time_limit} 
            onComplete={onStart}
            key={`instruction-${sectionId}`}
          />
        </div>
      )}
      
      <p className="text-gray-700 text-base mb-5 whitespace-pre-line leading-relaxed">
        {instruction.instruction}
      </p>
      
      <button
        onClick={onStart}
        className="w-full bg-secondary hover:bg-opacity-90 text-white font-bold py-3 rounded-lg text-base transition"
      >
        Commencer cette dimension
      </button>
    </div>
  </div>
);

export default SectionInstructionScreen;
